export default __webpack_public_path__ + "static/media/You&Me.aab4e153.mp4";